import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import StatusBadge from "@/components/StatusBadge";
import DataTable from "@/components/DataTable";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function Actions() {
  const { labels, selectedSite } = useApp();
  const [rows, setRows] = useState([]);
  const [ops, setOps] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const today = new Date().toISOString().slice(0, 10);
  const empty = { intitule: "", responsable: "", echeance: today, priorite: "moyenne", statut: "ouverte", preuveAttendue: "", operationId: "", origine: "Saisie manuelle" };
  const [form, setForm] = useState(empty);

  const load = () => {
    api.get("/actions").then((r) => setRows(r.data));
    api.get("/operations").then((r) => setOps(r.data));
  };
  useEffect(load, []);

  const opSiteMap = Object.fromEntries(ops.map((o) => [o.id, o.siteId]));
  const filtered = selectedSite === "all" ? rows : rows.filter((r) => opSiteMap[r.operationId] === selectedSite);

  const changeStatut = async (a, statut) => { try { await api.put(`/actions/${a.id}`, { statut }); toast.success("Action mise à jour"); load(); } catch (e) { toast.error(apiErr(e)); } };
  const create = async () => {
    try { await api.post("/actions", { ...form, operationId: form.operationId || null }); toast.success("Action créée"); setForm(empty); setShowForm(false); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  const overdue = (r) => r.echeance && r.echeance < today && ["ouverte", "en_cours", "a_verifier"].includes(r.statut);
  const columns = [
    { key: "intitule", label: "Intitulé", render: (r) => <span>{r.intitule}{overdue(r) && <span className="badge b-expire" style={{ marginLeft: 6 }}>En retard</span>}</span> },
    { key: "origine", label: "Origine", mono: true, width: 160, render: (r) => <span style={{ fontSize: ".72rem" }}>{r.origine}</span> },
    { key: "responsable", label: "Responsable", width: 150 },
    { key: "echeance", label: "Échéance", mono: true, width: 110 },
    { key: "priorite", label: "Priorité", width: 110, filter: Object.entries(labels.priorite).map(([value, label]) => ({ value, label })), render: (r) => <StatusBadge value={r.priorite} label={labels.priorite[r.priorite]} /> },
    { key: "statut", label: "Statut", width: 150, filter: Object.entries(labels.statutAction).map(([value, label]) => ({ value, label })),
      render: (r) => (
        <select value={r.statut} data-testid={`action-statut-${r.id}`} onClick={(e) => e.stopPropagation()} onChange={(e) => changeStatut(r, e.target.value)} style={{ padding: "4px 6px", fontSize: ".76rem" }}>
          {Object.entries(labels.statutAction).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
      ) },
  ];

  return (
    <div>
      <div className="page-head">
        <div><div className="crumb">Suivi</div><h1>Plan d'actions</h1></div>
        <button className="btn btn-p" onClick={() => setShowForm((s) => !s)} data-testid="new-action-btn"><Plus size={15} />Nouvelle action</button>
      </div>

      {showForm && (
        <div className="card" data-testid="action-form">
          <div className="row2">
            <div><label className="f">Intitulé</label><input value={form.intitule} onChange={(e) => setForm({ ...form, intitule: e.target.value })} data-testid="action-intitule" /></div>
            <div><label className="f">Responsable</label><input value={form.responsable} onChange={(e) => setForm({ ...form, responsable: e.target.value })} /></div>
          </div>
          <div className="row3">
            <div><label className="f">Échéance</label><input type="date" value={form.echeance} onChange={(e) => setForm({ ...form, echeance: e.target.value })} /></div>
            <div><label className="f">Priorité</label><select value={form.priorite} onChange={(e) => setForm({ ...form, priorite: e.target.value })}>{Object.entries(labels.priorite).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select></div>
            <div><label className="f">Opération liée</label><select value={form.operationId} onChange={(e) => setForm({ ...form, operationId: e.target.value })}><option value="">—</option>{ops.map((o) => <option key={o.id} value={o.id}>{o.id}</option>)}</select></div>
          </div>
          <label className="f">Preuve attendue</label>
          <input value={form.preuveAttendue} onChange={(e) => setForm({ ...form, preuveAttendue: e.target.value })} />
          <div style={{ marginTop: 14 }}><button className="btn btn-p" onClick={create} disabled={!form.intitule} data-testid="action-create">Créer</button></div>
        </div>
      )}

      <DataTable testid="actions-table" columns={columns} data={filtered} searchKeys={["intitule", "responsable", "origine"]} />
    </div>
  );
}
